import { useFormikContext } from "formik";
import {
  IdentityMelcoModelsProductListItem,
  InputField,
  TextAreaField,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Space, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayEditProductFormProps = {
  ProductDetails: IdentityMelcoModelsProductListItem;
};

export const DisplayEditProductForm: React.FC<DisplayEditProductFormProps> = ({
  ProductDetails,
}) => {
  const { t } = useTranslation();
  const { isSubmitting, submitForm } = useFormikContext();

  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          <Button
            icon={<SaveIcon />}
            type="primary"
            // disabled={isSubmitting}
            loading={isSubmitting}
            onClick={() => {
              submitForm();
            }}
            style={{ marginBottom: "15px" }}
          >
            {t("products_list.edit.drawer.actions.update.button")}
          </Button>
        </Right>

        <VerticalForm>
          <InputField
            name="code"
            label={t("products_list.edit.drawer.form.inputs.code")}
            value={ProductDetails.code ? ProductDetails.code : ""}
            readOnly
            disabled
          />
          <InputField
            name="name"
            label={t("products_list.edit.drawer.form.inputs.name")}
            value={ProductDetails.name ? ProductDetails.name : ""}
          />

          <TextAreaField
            name="description"
            label={t("products_list.edit.drawer.form.inputs.description")}
            value={ProductDetails.description ? ProductDetails.description : ""}
          />
          <InputField
            name="app_startup_endpoint"
            label={t(
              "products_list.edit.drawer.form.inputs.app_startup_endpoint"
            )}
            value={
              ProductDetails.app_startup_endpoint
                ? ProductDetails.app_startup_endpoint
                : ""
            }
          />
          <InputField
            name="auto_login_endpoint"
            label={t(
              "products_list.edit.drawer.form.inputs.auto_login_endpoint"
            )}
            value={
              ProductDetails.auto_login_endpoint
                ? ProductDetails.auto_login_endpoint
                : ""
            }
            readOnly
            disabled
          />
          <InputField
            name="legal_policy_version"
            label={t(
              "products_list.edit.drawer.form.inputs.legal_policy_version"
            )}
            value={
              ProductDetails.legal_policy_version
                ? ProductDetails.legal_policy_version
                : ""
            }
            disabled
          />
          <InputField
            name="is_demo_available"
            label={t("products_list.edit.drawer.form.inputs.is_demo_available")}
            value={ProductDetails.is_demo_available ? "true" : "false"}
            readOnly
            disabled
          />
          <InputField
            name="is_internal"
            label={t("products_list.edit.drawer.form.inputs.is_internal")}
            value={ProductDetails.is_internal ? "true" : "false"}
            readOnly
            disabled
          />
          <InputField
            name="account_verification_required"
            label={t(
              "products_list.edit.drawer.form.inputs.account_verification_required"
            )}
            value={
              ProductDetails.account_verification_required ? "true" : "false"
            }
            readOnly
            disabled
          />
          <InputField
            name="security_type"
            label={t("products_list.edit.drawer.form.inputs.security_type")}
            value={
              ProductDetails.security_type ? ProductDetails.security_type : ""
            }
            readOnly
            disabled
          />
          <InputField
            name="devices_allowed"
            label={t("products_list.edit.drawer.form.inputs.devices_allowed")}
            value={
              ProductDetails.devices_allowed
                ? ProductDetails.devices_allowed
                : ""
            }
          />
          <InputField
            name="max_devices_allowed"
            label={t(
              "products_list.edit.drawer.form.inputs.max_devices_allowed"
            )}
            value={
              ProductDetails.max_devices_allowed
                ? ProductDetails.max_devices_allowed
                : ""
            }
          />
          <InputField
            name="offline_seconds_allowed"
            label={t(
              "products_list.edit.drawer.form.inputs.offline_seconds_allowed"
            )}
            value={
              ProductDetails.offline_seconds_allowed
                ? ProductDetails.offline_seconds_allowed
                : ""
            }
          />

          <InputField
            name="seconds_to_relogin"
            label={t(
              "products_list.edit.drawer.form.inputs.seconds_to_relogin"
            )}
            value={
              ProductDetails.seconds_to_relogin
                ? ProductDetails.seconds_to_relogin
                : ""
            }
          />

          <InputField
            name="send_notification_emails"
            label={t(
              "products_list.edit.drawer.form.inputs.send_notification_emails"
            )}
            value={ProductDetails.send_notification_emails ? "true" : ""}
            readOnly
            disabled
          />
        </VerticalForm>
      </div>
    </>
  );
};
